export default {
  rentProducts: [],
  loading: false,
}
